export default __webpack_public_path__ + "static/media/live-feed-close.f8184218.svg";